export default {
    
    en: {
        remindTaskStatus: 'Remind Task Status',
        remindTaskDetail: 'Remind Task Detail',
        orderNo: 'Order Number',
        createTime: 'Create Time',
        endDate: 'End Date',
        remindRecord: 'Remind Record',
        userName: 'User Name',
        remindNumber: 'Remind Number',
        settleNumber: 'Settle Number',
        diferNumber: 'Difer Number',
        overdueNumber: 'Overdue Number',
        dealWith: 'Deal With',
        endTime: 'End Date',
    }
}